import {isNil} from "lodash"
import {CommonRequestKeys} from "../../../../shared-components/common/constants/requests"
import {REQUEST, REQUEST_FAILURE, REQUEST_SUCCESS} from "../../../../shared-components/store/requests/requestsReducer"
import {SELECT_AREA} from "./detailsActionsTypes"

const details = (state = {}, action = {}) => {
    switch (action.type) {
        case REQUEST_SUCCESS:
            if (action.requestKeyName === CommonRequestKeys.USER_INFO) {
                return {
                    sap: {
                        civilite: action.payload.civilite,
                        nom: action.payload.nom,
                        prenom: action.payload.prenom,
                        beneficiaireId: action.payload.beneficiaireId,
                        espaces: action.payload.espaces,
                        selectedArea: state.selectedArea,
                        compteEBCESU: action.payload.compteEBCESU,
                    },
                    cesu: !isNil(state.cesu) ? state.cesu : {},
                }
            } else {
                return state
            }
        case REQUEST:
            if (action.requestKeyName === CommonRequestKeys.USER_INFO) {
                return {
                    sap: {...state.sap, selectedArea: state.selectedArea},
                    cesu: !isNil(state.cesu) ? state.cesu : {},
                }
            } else {
                return state
            }
        case REQUEST_FAILURE:
            if (action.requestKeyName === CommonRequestKeys.USER_INFO) {
                return {
                    sap: {...state.sap, selectedArea: state.selectedArea},
                    cesu: !isNil(state.cesu) ? state.cesu : {},
                }
            } else {
                return state
            }
        case SELECT_AREA: {
            return {
                sap: {
                    ...state.sap,
                    selectedArea: action.area,
                },
                cesu: !isNil(state.cesu) ? state.cesu : {},
            }
        }
        default:
            return state
    }
}

export default details

/**
 * Get user details from the store.
 */
export const getDetails = state => state
